<template>
    <b-modal id="nichibo-add-by-stockno" title="Manually add nichibo stock" ref="modal">
        <div class="vehicle-stock-container">
            <p>
                Please enter the Nichibo stock number below. This will search all nichibo users.
            </p>
            <messages :messages="messages" :scroll="true"/>
            <div v-if="vehicle_link" class="alert alert-danger">
                <a :href="vehicle_link">Vehicle link</a>
            </div>
            <b-form-group label="Nichibo Stock Number"
                          :label-for="getId('nichibo_stock_number')"
                          :state="fieldState('nichibo_stock_number')"
                          :invalid-feedback="invalidField('nichibo_stock_number')"
            >
                <b-form-input
                    :id="getId('nichibo_stock_number')"
                    type="number"
                    ref="stockNumber"
                    v-model="nichibo_stock_number"
                    :state="fieldState('nichibo_stock_number')"
                    placeholder="Enter Stock Number">
                </b-form-input>
            </b-form-group>
        </div>
        <template v-slot:modal-footer="ok, cancel, hide ">
            <div v-if="loading" class="alert alert-info">
                This can take up to 30 seconds depending on how many images there are.
            </div>
            <icon :loading="loading" />
            <b-button size="sm" variant="success" @click="onSubmit()" :disabled="loading">
                OK
            </b-button>
            <b-button size="sm" variant="danger" @click="closeModal()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import {getExceptionErrorMessage, getHttpValidationErrors, objLookup, laravelRoute} from "../../util/common";
    import BootstrapValidation from '../../mixins/bootstrap-validation';
    export default {
        components: {
        },
        mixins: [BootstrapValidation],
        data() {
            return {
                nichibo_stock_number: null,
                loading: false,
                vehicle_link: false,
                messages: [],
            }
        },
        methods: {
            openModal(){
                this.$refs.modal.show();
                setTimeout(() =>{
                    this.$refs.stockNumber.focus();
                }, 200);
            },
            closeModal(){
                this.$refs.modal.hide();
            },
            async onSubmit() {
                this.loading = true;
                this.vehicle_link = false;
                this.messages = [];
                this.errors = [];
                try {
                    let url = this.$laravelRoute('vehicle-stock.create-by-stock-number');
                    let res = await this.axios.post(url, {nichibo_stock_number: this.nichibo_stock_number});
                    if (res && res.data && res.data.vehicle_stock) {
                        this.$router.push('/vehicle-stock/' + res.data.vehicle_stock.id);
                    } else {
                        this.messages.push({type: 'danger', message: 'Unable to create.'});
                    }
                } catch (e) {
                    const errors = getHttpValidationErrors(e)
                    const data = objLookup(e, 'response.data.vehicle_sold');
                    let message = getExceptionErrorMessage(e)
                    if (data) {
                        if (data.vehicle_stock_id) {
                            this.vehicle_link = laravelRoute('vehicle-stock.show', data.vehicle_stock_id)
                        }
                    }
                    if (message) {
                        this.messages.push({type: 'danger', message});
                    }
                    if (errors) {
                        this.errors = errors;
                    }
                }

                this.loading = false;

            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/CreateByNichiboStockNo.vue